/** Release held input on every lifecycle exit, including teardown without blur. */
export function installInputCancellation(reset:()=>void,target:EventTarget,doc?:EventTarget&{readonly hidden:boolean}):()=>void {
  const hidden=()=>{if(doc?.hidden)reset();};
  target.addEventListener('blur',reset);
  target.addEventListener('gameplay-input-reset',reset);
  doc?.addEventListener('visibilitychange',hidden);
  return ()=>{
    target.removeEventListener('blur',reset);
    target.removeEventListener('gameplay-input-reset',reset);
    doc?.removeEventListener('visibilitychange',hidden);
    reset();
  };
}
